import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import Delete from "../../../images/delete.svg";
import { useSelector } from "react-redux";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";

function MemberFeedback({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [resetPage, setResetPage] = useState(false);
  const [searchMail, setSearchMail] = useState("");

  // console.log(window.location);
  // console.log(match.url);
  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.memberFeedbackGet(payload);
      console.log(postData);
      setData(postData.post);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page, resetPage]);

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.memberFeedbackSeacrh(payload);
      // console.log(res);
      if (res?.success) {
        setData(res?.feedback);
      } else {
        alert("Email address not found");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid payHistoryPage">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12  d-flex justify-content-between pr-0">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Member Feedback ({noOfPost})
                </h4>
                <div className="searchMadmin">
                  <div className="inputM">
                    <div className="iM">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        onChange={(e) => setSearchMail(e.target.value)}
                        type="text"
                        placeholder="Search by email..."
                      />
                    </div>
                    <i
                      className="fa-solid fa-magnifying-glass sIcon"
                      onClick={handleSearch}
                    ></i>
                  </div>
                  <button className="reset" onClick={() => handleReset()}>
                    <i className="fa-solid fa-arrow-rotate-right"></i>
                    Reset
                  </button>
                </div>
                {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
              </div>
            </div>
            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfPost={noOfPost}
              limit={limit}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noOfPost, limit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const handleChange = (event, value) => {
    setPage(value);
  };
  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    <div className="w-max">Email</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Satisfaction Level</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Feature Exlored</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Feature Rating</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Recommend Others</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Like Most</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">How We Improve</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Suggestions</div>
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Submitted At</div>
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark db">
                        {item?.user?.email}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark db">
                        {item?.satisfaction_level}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark db">
                        <ul className="">
                          {item.features_explored.map((f, i) => (
                            <li key={i}>
                              <div className="table-text-dark w-max db">
                                {f}
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </td>
                    <td>
                      <ul>
                        <li>
                          Crypto_Trade_Signals{" "}
                          {item?.feature_helpfulness?.Crypto_Trade_Signals}/5
                        </li>
                        <li>
                          <div className="table-text-dark w-max db">
                            Stock_and_Commodity{" "}
                            {item?.feature_helpfulness?.Stock_and_Commodity}/5
                          </div>
                        </li>
                        <li>
                          Market_Updates{" "}
                          {item?.feature_helpfulness?.Market_Updates}/5
                        </li>
                        <li>
                          Web3_Education{" "}
                          {item?.feature_helpfulness?.Web3_Education}/5
                        </li>
                      </ul>
                    </td>
                    <td>
                      <div className="table-text-dark db">
                        {item?.recommend_others}
                      </div>
                    </td>
                    <td>
                      <div
                        className="table-text-dark db"
                        style={{ minWidth: 200 }}
                      >
                        {item?.about_premium_comment}
                      </div>
                    </td>
                    <td>
                      <div
                        className="table-text-dark db"
                        style={{ minWidth: 200 }}
                      >
                        {item?.improve_experience}
                      </div>
                    </td>
                    <td>
                      <div
                        className="table-text-dark db"
                        style={{ minWidth: 200 }}
                      >
                        {item?.suggestions}
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.submitted_at)}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default MemberFeedback;
